// extracted by mini-css-extract-plugin
module.exports = {"headerRight":"App_headerRight__c8JLG","user":"App_user__37wXI","userAvatar":"App_userAvatar__27hWL","username":"App_username__3maWy"};